module.exports = __webpack_public_path__ + "img/131.31b6933e.jpg";